import NoDataCard from './noDataCard'
export default NoDataCard
